import React from 'react';

/**
 * Shared empty state used across all tabs/pages.
 * Renders a centered icon, heading, optional subtext, and optional action button.
 *
 * Props:
 *   icon         – emoji string or React node (default: '📦')
 *   heading      – required main heading text
 *   message      – optional subdued subtext
 *   actionContent – button label (requires onAction)
 *   onAction     – click handler for the action button
 *   actionVariant – s-button variant (default: 'secondary')
 */
function EmptyState({
  icon = '📦',
  heading,
  message,
  actionContent,
  onAction,
  actionVariant = 'secondary',
}) {
  return (
    <s-box padding="extra-large">
      <s-stack gap="base" alignItems="center">
        <div className="es-icon">{icon}</div>

        <s-stack gap="extra-tight" alignItems="center">
          <s-text type="strong" size="large" style={{ textAlign: 'center' }}>{heading}</s-text>
          {message && (
            <s-text tone="subdued" style={{ textAlign: 'center', maxWidth: 420, display: 'block' }}>
              {message}
            </s-text>
          )}
        </s-stack>

        {actionContent && onAction && (
          <s-button variant={actionVariant} onClick={onAction}>
            {actionContent}
          </s-button>
        )}
      </s-stack>
    </s-box>
  );
}

export default EmptyState;
